import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { PwaInstallMode, PwaInstallService } from "src/app/core/services/pwa-install.service";

/** Laisse l'application s'afficher avant de proposer l'installation. */
const SHOW_DELAY_MS = 2500;

/**
 * Dialogue proposé à chaque visite tant que l'application n'est pas installée : « Plus tard » le masque pour la
 * visite en cours seulement. Montée une fois pour toute l'application (app.component.html).
 */
@Component({
	selector: "app-pwa-install-prompt",
	templateUrl: "./pwa-install-prompt.component.html",
	styleUrls: ["./pwa-install-prompt.component.scss"],
})
export class PwaInstallPromptComponent implements OnInit, OnDestroy {
	@ViewChild("primaryBtn") primaryBtn?: ElementRef<HTMLButtonElement>;

	protected isOpen = false;
	protected mode: PwaInstallMode | null = null;

	private subscription?: Subscription;
	private timer?: ReturnType<typeof setTimeout>;

	constructor(
		private pwaInstallService: PwaInstallService,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		this.subscription = this.pwaInstallService.mode$.subscribe((mode) => {
			this.mode = mode;
			clearTimeout(this.timer);

			if (!mode) {
				this.isOpen = false;
				return;
			}
			this.timer = setTimeout(() => this.open(), SHOW_DELAY_MS);
		});

		// Demandé par l'utilisateur (bouton du menu) : tout de suite, sans le délai de la proposition automatique
		this.subscription.add(
			this.pwaInstallService.reopen$.subscribe((mode) => {
				this.mode = mode;
				clearTimeout(this.timer);
				this.open();
			})
		);
	}

	ngOnDestroy(): void {
		clearTimeout(this.timer);
		this.subscription?.unsubscribe();
	}

	@HostListener("document:keydown.escape")
	onEscape(): void {
		if (this.isOpen) this.later();
	}

	install(): void {
		this.pwaInstallService.install();
	}

	later(): void {
		this.pwaInstallService.dismiss();
	}

	private open(): void {
		this.isOpen = true;
		// le bouton n'existe qu'une fois le dialogue rendu : on le rend d'abord, puis on lui donne le focus
		this.cdr.detectChanges();
		this.primaryBtn?.nativeElement.focus();
	}
}
